import { useModuleConfig } from '@/utils/hooks/useModuleConfig'
import { Module, ModuleOptionsValue } from '../../companies'

export interface SalaryModuleConfiguration {
  driverApprove: boolean
  managerApprove: boolean
  onlyIncludeApprovedHours: boolean
}

export const useSalaryModuleConfiguration = () => {
  const { getModuleOptionStatus } = useModuleConfig(Module.SALARY)

  const driverApproveEnabled = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_USER_APPROVE_HOURS
  )
  const managerApproveEnabled = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_LEADER_APPROVE_HOURS
  )
  const onlyIncludeApprovedHours = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_ONLY_INCLUDE_APPROVED_HOURS
  )

  const canTransferWorkToAbsence = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_ALLOW_TRANSFER_OF_HOURS_TO_ABSENCES
  )

  const requireCommentOnDriverApproval = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_REQUIRE_COMMENT_ON_DRIVER_APPROVAL
  )
  const requireCommentOnManagerApproval = getModuleOptionStatus(
    ModuleOptionsValue.SALARY_REQUIRE_COMMENT_ON_MANAGER_APPROVAL
  )

  return {
    driverApprove: driverApproveEnabled,
    managerApprove: managerApproveEnabled,
    canTransferWorkToAbsence,
    onlyIncludeApprovedHours:
      onlyIncludeApprovedHours &&
      (driverApproveEnabled || managerApproveEnabled),
    requireCommentOnDriverApproval,
    requireCommentOnManagerApproval,
  }
}
